import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../utils/constants';

const ResetPasswordPage = ({ onComplete }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError(t('resetPage.passwordsMismatch'));
      return;
    }
    if (password.length < 8) {
      setError(t('resetPage.passwordTooShort'));
      return;
    }

    setLoading(true);
    setError('');

    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setSuccess(true);
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px', background: 'var(--bg-card)', borderRadius: '20px', padding: '40px', boxShadow: 'var(--shadow-lg)' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>{success ? '✅' : '🔑'}</div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
            {success ? t('resetPage.passwordUpdated') : t('resetPage.setNewPassword')}
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
            {success ? t('resetPage.redirecting') : t('resetPage.enterNewPassword')}
          </p>
        </div>

        {!success && (
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder={t('resetPage.newPasswordPlaceholder')}
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{
                width: '100%', padding: '14px 16px', borderRadius: '10px',
                border: '2px solid var(--border-color)', background: 'var(--bg-secondary)',
                color: 'var(--text-primary)', fontSize: '15px', marginBottom: '12px',
                outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box'
              }}
              required
              minLength={8}
            />
            <input
              type="password"
              placeholder={t('resetPage.confirmPasswordPlaceholder')}
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              style={{
                width: '100%', padding: '14px 16px', borderRadius: '10px',
                border: '2px solid var(--border-color)', background: 'var(--bg-secondary)',
                color: 'var(--text-primary)', fontSize: '15px', marginBottom: '16px',
                outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box'
              }}
              required
              minLength={8}
            />

            {error && <p style={{ color: 'var(--error)', fontSize: '13px', marginBottom: '12px', textAlign: 'center' }}>{error}</p>}

            <button
              type="submit"
              style={{
                width: '100%', padding: '14px', borderRadius: '10px', border: 'none',
                background: 'var(--accent-gradient)', color: 'white',
                fontSize: '15px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit',
                opacity: loading ? 0.7 : 1
              }}
              disabled={loading}
            >
              {loading ? t('resetPage.updating') : t('resetPage.updatePassword')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
